import {
  DataProvider,
  GetOneParams,
  GetOneResult,
  UpdateParams,
  UpdateResult,
} from "react-admin";
import baseDataProvider from "../dataProvider/baseDataProvider";
import { gql, postGraphql, postGraphqlMutation } from "../dataProvider/utils";

const clinicDiPracticeMappingsDataProvider: DataProvider = {
  ...baseDataProvider,
  async getOne(
    resource: string,
    params: GetOneParams
  ): Promise<GetOneResult<any>> {
    const response = await postGraphql(
      gql`
        query UAClinicDIPracticeMappingGetOne($id: ID!) {
          clinic(id: $id) {
            id
            name
            diPracticeId
          }
        }
      `,
      { id: params.id }
    );
    const { clinic } = response.json.data;
    return { data: clinic };
  },

  async update(
    resource: string,
    params: UpdateParams
  ): Promise<UpdateResult<any>> {
    const { id, data } = params;
    const response = await postGraphqlMutation(
      gql`
        mutation UAClinicDIPracticeMappingUpdate(
          $id: ID!
          $input: UpdateClinicDIPracticeMappingInput!
        ) {
          mutation: updateClinicDIPracticeMapping(id: $id, input: $input) {
            status
            errors {
              key
              details {
                code
                message
              }
            }
            payload {
              id
              name
            }
          }
        }
      `,
      {
        id,
        input: {
          diPracticeId: data.remove ? null : data.diPracticeId,
        },
      },
      "mutation"
    );
    return {
      data: { ...data, ...response.json.data.mutation.payload },
    };
  },
};

export default clinicDiPracticeMappingsDataProvider;
